import React, { useState, useEffect } from "react";
import {
  AbsoluteCenter,
  ChakraProvider,
  Box,
  Card,
  Center,
  Button,
  Flex,
  Text,
  Heading,
  VStack,
  HStack,
  Image,
  SimpleGrid,
  Grid,
  GridItem,
  Select,
  Spinner,
  Stepper,
  Step,
  StepIndicator,
  StepIcon,
  StepNumber,
  FormLabel,
  FormControl,
  FormErrorMessage,
  Textarea,
  Input,
  StepSeparator,
  StepStatus,
  useColorModeValue,
  useSteps,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ColorModeSwitcher } from "../../ColorModeSwitcher";
import { Nav } from "../../containers/Nav";
import { createBrandCampaign } from "../../actions/campaigns";

function Step1(props) {
  const campaignName = props.campaignName;
  const campaignCoverImage = props.campaignCoverImage;
  const campaignDescription = props.campaignDescription;
  const campaignMedium = props.campaignMedium;
  const campaignGenre = props.campaignGenre;
  const campaignHome = props.campaignHome;
  const campaignStage = props.campaignStage;

  const setCampaignName = props.setCampaignName;
  const setCampaignCoverImage = props.setCampaignCoverImage;
  const setCampaignDescription = props.setCampaignDescription;
  const setCampaignMedium = props.setCampaignMedium;
  const setCampaignGenre = props.setCampaignGenre;
  const setCampaignHome = props.setCampaignHome;
  const setCampaignStage = props.setCampaignStage;

  const [name, setName] = useState(campaignName || "");
  const [coverImage, setCoverImage] = useState(campaignCoverImage || "");
  const [description, setDescription] = useState(campaignDescription || "");
  const [medium, setMedium] = useState(campaignMedium || "");
  const [genre, setGenre] = useState(campaignGenre || "");
  const [home, setHome] = useState(campaignHome || "");
  const [stage, setStage] = useState(campaignStage || "");

  const [nameErr, setNameErr] = useState("");
  const [coverImageErr, setCoverImageErr] = useState("");
  // const [coverImageBlog, setCoverImageBlog] = useState()
  const [descriptionErr, setDescriptionErr] = useState("");
  const [mediumErr, setMediumErr] = useState("");
  const [genreErr, setGenreErr] = useState("");
  const [homeErr, setHomeErr] = useState("");
  const [stageErr, setStageErr] = useState("");

  const { currentStep, setCurrentStep } = props;

  const submitCoverImage = (image) => {
    if (!image) return;
    if (image.size / 1000 / 1000 > 25) {
      setCoverImageErr("Image can't be larger than 25mb");
    }
    setCoverImage(image);
  };

  return (
    <Box>
      <VStack>
        <Box>
          <VStack>
            <Box
              width="300px"
              height="225px"
              alignItems="center"
              overflow="hidden"
              borderRadius="xl"
            >
              <Image
                borderWidth="2px"
                borderRadius="xl"
                objectFit="cover"
                src={
                  coverImage
                    ? URL.createObjectURL(coverImage)
                    : "https://placehold.co/300x225"
                }
              />
            </Box>
            <Input
              display="none"
              position="absolute"
              width="0px"
              name="cover-image-upload"
              id="cover-image-upload"
              accept="image/png, image/jpeg"
              type="file"
              onChange={(e) => {
                //console.log(e.target.files[0]);
                submitCoverImage(e.target.files[0]);
              }}
            ></Input>
            <Text as="span" color="red.500">
              {coverImageErr}
            </Text>
            <FormLabel
              borderRadius="md"
              border="1px"
              cursor="pointer"
              padding="6px"
              outline="0"
              htmlFor="cover-image-upload"
            >
              <Text as="b">Upload cover image</Text>
            </FormLabel>
          </VStack>
        </Box>

        <Box width="100%" my="2" px="5">
          <Text as="b">
            What’s the name of your campaign? Users will see this.
          </Text>
          <FormControl isInvalid={nameErr}>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Campaign Name"
            />
            <FormErrorMessage>{nameErr}</FormErrorMessage>
          </FormControl>
        </Box>
        <Box width="100%" my="2" px="5">
          <Text as="b">Description</Text>
          <FormControl isInvalid={descriptionErr}>
            <Textarea
              isInvalid={descriptionErr}
              onChange={(e) => setDescription(e.target.value)}
              value={description}
              variant="outline"
              width="100%"
              placeholder="Describe the campaign as you would to a consumer"
            />
            <FormErrorMessage>{descriptionErr}</FormErrorMessage>
          </FormControl>
        </Box>

        <Box width="100%" my="2" px="5">
          <Text as="b">What are you looking to test?</Text>
          <FormControl isInvalid={mediumErr}>
            <Select
              onChange={(e) => setMedium(e.target.value)}
              value={medium}
              placeholder="Select medium"
            >
              <option value="show">Show</option>
              <option value="tv">TV</option>
              <option value="film">Film</option>
              <option value="other">Other</option>
            </Select>
            <FormErrorMessage>{mediumErr}</FormErrorMessage>
          </FormControl>
        </Box>

        <Box width="100%" my="2" px="5">
          <Text as="b">What type of genre is it?</Text>
          <FormControl isInvalid={genreErr}>
            <Select
              onChange={(e) => setGenre(e.target.value)}
              value={genre}
              placeholder="Select genre"
            >
              <option value="romance">Romance</option>
              <option value="comedy">Comedy</option>
              <option value="drama">Drama</option>
              <option value="fantasy">Fantasy</option>
              <option value="thriller">Thriller/Horror</option>
            </Select>
            <FormErrorMessage>{genreErr}</FormErrorMessage>
          </FormControl>
        </Box>

        <Box width="100%" my="2" px="5">
          <Text as="b">Where do you want the content to live?</Text>
          <FormControl isInvalid={homeErr}>
            <Select
              onChange={(e) => setHome(e.target.value)}
              value={home}
              placeholder="Select home"
            >
              <option value="romance">Streamer</option>
              <option value="comedy">Traditional Cable</option>
              <option value="online">Online/Social</option>
              <option value="podcast">Podcast</option>
              <option value="Theater">Theater</option>
              <option value="other">Other</option>
            </Select>
            <FormErrorMessage>{homeErr}</FormErrorMessage>
          </FormControl>
        </Box>

        <Box width="100%" my="2" px="5">
          <Text as="b">What stage is your content at?</Text>
          <FormControl isInvalid={stageErr}>
            <Select
              onChange={(e) => setStage(e.target.value)}
              value={stage}
              placeholder="Select stage"
            >
              <option value="pre_production">Pre-Production</option>
              <option value="in_production">In Production</option>
              <option value="post_production">Post-Production</option>
            </Select>
            <FormErrorMessage>{stageErr}</FormErrorMessage>
          </FormControl>
        </Box>

        <Center>
          <Button
            colorScheme="green"
            onClick={() => {
              let errors = false;
              setNameErr("");
              setCoverImageErr("");
              setDescriptionErr("");
              setMediumErr("");
              setGenreErr("");
              setHomeErr("");
              setStageErr("");

              if (!coverImage || coverImage === "") {
                setCoverImageErr("Campaign cover image is required");
                errors = true;
              }
              if (!name || name === "") {
                setNameErr("Campaign name can not be blank");
                errors = true;
              }
              if (!description || description === "") {
                setDescriptionErr("Campaign description can not be blank");
                errors = true;
              }
              if (!medium || medium === "") {
                setMediumErr("Campaign medium is required");
                errors = true;
              }
              if (!genre || genre === "") {
                setGenreErr("Campaign genre required");
                errors = true;
              }
              if (!home || home === "") {
                setHomeErr("Campaign home is required");
                errors = true;
              }
              if (!stage || stage === "") {
                setStageErr("Campaign stage is required");
                errors = true;
              }

              if (errors) {
                return;
              }

              setCampaignName(name);
              setCampaignDescription(description);
              setCampaignCoverImage(coverImage);
              setCampaignMedium(medium);
              setCampaignGenre(genre);
              setCampaignHome(home);
              setCampaignStage(stage);

              setCurrentStep(currentStep + 1);
            }}
          >
            Next Step
          </Button>
        </Center>
      </VStack>
    </Box>
  );
}

function Step2(props) {
  const { currentStep, setCurrentStep, campaignTaglines, setCampaignTaglines } =
    props;

  const [tagLines, setTagLines] = useState(campaignTaglines || []);
  const [newTagLine, setNewTagLine] = useState("");
  const [taglineErr, setTaglineErr] = useState("");

  const addToTagLine = (value) => {
    if (!value) return;
    setTaglineErr("");
    setTagLines([...tagLines, value]);
    setNewTagLine("");
  };

  const removeTagLine = (i) => {
    tagLines.splice(i, 1);
    setTagLines([...tagLines]);
  };

  useEffect(() => {
    setTagLines(tagLines);
  }, tagLines);

  return (
    <Box>
      <Center>
        <Heading fontSize="2xl">Messaging Taglines</Heading>
      </Center>
      <Text my="2" fontSize="lg">
        Find out what messaging would make your audience want to engage with
        your content. Create a tagline and make it memorable!
      </Text>
      {/*<Text my="2" fontSize="lg">
        Upload upto 5 taglines for users to select from.
      </Text>*/}

      <VStack>
        {tagLines.map((tagLine, tdx) => {
          return (
            <Flex width="100%" my="2" px="5">
              <Input
                disabled={true}
                value={tagLine}
                width="100%"
                type="text"
                placeholder="Enter a selectable tag line"
              />
              <Button
                fontSize="lg"
                mx="2"
                colorScheme="red"
                onClick={() => {
                  removeTagLine(tdx);
                }}
              >
                -
              </Button>
            </Flex>
          );
        })}

        <Flex width="100%" my="2" px="5">
          <Input
            onChange={(e) => {
              setNewTagLine(e.target.value);
            }}
            value={newTagLine}
            width="100%"
            type="text"
            placeholder="Enter a selectable tag line"
          />
          <Button
            onClick={() => addToTagLine(newTagLine)}
            fontSize="lg"
            mx="2"
            colorScheme="teal"
          >
            +
          </Button>
        </Flex>
      </VStack>

      <Center my="1">
        <Text color="red.500">{taglineErr}</Text>
      </Center>
      <Center mt="5">
        <HStack>
          <Button
            colorScheme="teal"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            Go Back
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              setTaglineErr("");
              if (!tagLines.length || tagLines.length < 2) {
                setTaglineErr("At least two taglines are required.");
                return;
              }
              setCampaignTaglines(tagLines);
              setCurrentStep(currentStep + 1);
            }}
          >
            Next Step
          </Button>
        </HStack>
      </Center>
    </Box>
  );
}

function Step3(props) {
  const {
    currentStep,
    setCurrentStep,
    campaignConceptStorylines,
    setCampaignConceptStorylines,
  } = props;

  const [storyLines, setStorylines] = useState(campaignConceptStorylines || []);
  const [newStoryline, setNewStoryline] = useState("");
  const [err, setErr] = useState("");

  const addToStoryline = (value) => {
    if (!value) return;
    setErr("");
    setStorylines([...storyLines, value]);
    setNewStoryline("");
  };

  const removeStoryline = (i) => {
    storyLines.splice(i, 1);
    setStorylines([...storyLines]);
  };

  useEffect(() => {
    setStorylines(storyLines);
  }, storyLines);

  return (
    <Box>
      <Center>
        <Heading fontSize="2xl">Concept/Story</Heading>
      </Center>
      <Text my="2" mx="10" fontSize="lg">
        See what elevator pitch resonates with your audience! For instance, a
        film about 2 Robots from prominent families that hate each other fall in
        love. What’s the concept/story?{" "}
        <Text as="i">"iRobot meets Romeo and Juliet”</Text>.
      </Text>
      <Text my="4" mx="10" fontSize="lg">
        Upload upto 5 concepts for users to select from.
      </Text>

      <VStack>
        {storyLines.map((storyLine, idx) => {
          return (
            <Flex key={`storyline-${idx}`} width="100%" my="2" px="5">
              <Input
                disabled={true}
                value={storyLine}
                width="100%"
                type="text"
                placeholder="Enter a selectable concept/story"
              />
              <Button
                fontSize="lg"
                mx="2"
                colorScheme="red"
                onClick={() => {
                  removeStoryline(idx);
                }}
              >
                -
              </Button>
            </Flex>
          );
        })}

        <Flex width="100%" my="2" px="5">
          <Input
            onChange={(e) => {
              setNewStoryline(e.target.value);
            }}
            value={newStoryline}
            width="100%"
            type="text"
            placeholder="Enter a selectable concept/story"
          />
          <Button
            onClick={() => addToStoryline(newStoryline)}
            fontSize="lg"
            mx="2"
            colorScheme="teal"
          >
            +
          </Button>
        </Flex>
      </VStack>

      <Center my="1">
        <Text color="red.500">{err}</Text>
      </Center>
      <Center mt="5">
        <HStack>
          <Button
            colorScheme="teal"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            Go Back
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              if (!storyLines.length || storyLines.length < 2) {
                setErr("Two or more story lines are required");
                return;
              }
              setCampaignConceptStorylines([...storyLines]);
              setCurrentStep(currentStep + 1);
            }}
          >
            Next Step
          </Button>
        </HStack>
      </Center>
    </Box>
  );
}

function Step4(props) {
  const {
    currentStep,
    setCurrentStep,
    campaignCastImages,
    setCampaignCastImages,
  } = props;

  const [castImages, setCastImages] = useState(campaignCastImages || []);
  const [containsErrs, setContainsErrs] = useState(false);

  const addToCastImage = (value) => {
    if (!value) return;
    setCastImages([...castImages, value]);
  };

  const removeCastImage = (i) => {
    castImages.splice(i, 1);
    setCastImages([...castImages]);
  };

  useEffect(() => {
    setCampaignCastImages(campaignCastImages);
  }, campaignCastImages);

  return (
    <Box>
      <Center>
        <Heading fontSize="2xl">Cast</Heading>
      </Center>

      <Text my="2" fontSize="lg">
        Find out what cast members your audience want to engage with. Who is
        your dream cast?
      </Text>
      <Text my="2" fontSize="lg">
        Upload up to 5 images to get audience feedback
      </Text>

      <SimpleGrid columns={5} spacing={2} my="3">
        {castImages.map((castImg) => {
          return (
            <Box>
              <Image
                borderWidth="2px"
                borderRadius="xl"
                boxSize="135"
                objectFit="cover"
                src={
                  castImg
                    ? URL.createObjectURL(castImg)
                    : "https://placehold.co/300x225"
                }
              />
            </Box>
          );
        })}
        {castImages.length !== 5 && (
          <>
            <Input
              display="none"
              position="absolute"
              width="0px"
              name="cover-image-upload"
              id="cover-image-upload"
              accept="image/png, image/jpeg"
              type="file"
              onChange={(e) => {
                addToCastImage(e.target.files[0]);
              }}
            ></Input>
            <FormLabel
              cursor="pointer"
              htmlFor="cover-image-upload"
              position="relative"
              fontSize="xl"
              width="133px"
              height="133px"
              background="blue.100"
              borderStyle="dashed"
              borderColor="blue.200"
              borderWidth="2px"
              borderRadius="xl"
              justifyContent="center"
            >
              <AbsoluteCenter>
                <Text
                  color="blue.300"
                  lineHeight="30px"
                  as="span"
                  fontSize="55px"
                >
                  +
                </Text>
              </AbsoluteCenter>
            </FormLabel>
          </>
        )}
      </SimpleGrid>
      {containsErrs && (
        <Text color="red.500">At least 2 images are required</Text>
      )}
      <Center>
        <HStack>
          <Button
            colorScheme="teal"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            Go Back
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              setContainsErrs(false);
              if (castImages.length < 2) {
                setContainsErrs(true);
                return;
              }
              // No errors:
              setCampaignCastImages(castImages);
              setCurrentStep(currentStep + 1);
            }}
          >
            Next Step
          </Button>
        </HStack>
      </Center>
    </Box>
  );
}

function Step5(props) {
  const {
    currentStep,
    setCurrentStep,
    campaignThemeImages,
    setCampaignThemeImages,
  } = props;

  const [themeImages, setThemeImages] = useState(campaignThemeImages || []);
  const [containsErrs, setContainsErrs] = useState(false);

  const addToThemeImage = (value) => {
    if (!value) return;
    setThemeImages([...themeImages, value]);
  };

  const removeThemeImage = (i) => {
    themeImages.splice(i, 1);
    setThemeImages([...themeImages]);
  };

  useEffect(() => {
    setCampaignThemeImages(campaignThemeImages);
  }, campaignThemeImages);

  return (
    <Box>
      <Center>
        <Heading fontSize="2xl">Art/Theme</Heading>
      </Center>

      <Text my="2" fontSize="lg">
        Whether it’s coming of age, good versus evil or parenthood, your product
        has a theme! Tell us in pictures.
      </Text>
      <Text my="2" fontSize="lg">
        Upload up to 5 images for audience feedback
      </Text>

      <SimpleGrid columns={5} spacing={2} my="3">
        {themeImages.map((castImg) => {
          return (
            <Box>
              <Image
                borderWidth="2px"
                borderRadius="xl"
                boxSize="135"
                objectFit="cover"
                src={
                  castImg
                    ? URL.createObjectURL(castImg)
                    : "https://placehold.co/300x225"
                }
              />
            </Box>
          );
        })}
        {themeImages.length !== 5 && (
          <>
            <Input
              display="none"
              position="absolute"
              width="0px"
              name="cover-image-upload"
              id="cover-image-upload"
              accept="image/png, image/jpeg"
              type="file"
              onChange={(e) => {
                addToThemeImage(e.target.files[0]);
              }}
            ></Input>
            <FormLabel
              cursor="pointer"
              htmlFor="cover-image-upload"
              position="relative"
              fontSize="xl"
              width="133px"
              height="133px"
              background="blue.100"
              borderStyle="dashed"
              borderColor="blue.200"
              borderWidth="2px"
              borderRadius="xl"
              justifyContent="center"
            >
              <AbsoluteCenter>
                <Text
                  color="blue.300"
                  lineHeight="30px"
                  as="span"
                  fontSize="55px"
                >
                  +
                </Text>
              </AbsoluteCenter>
            </FormLabel>
          </>
        )}
      </SimpleGrid>
      {containsErrs && (
        <Text color="red.500">At least 2 images are required</Text>
      )}
      <Center>
        <HStack>
          <Button
            colorScheme="teal"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            Go Back
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              setContainsErrs(false);
              if (themeImages.length < 2) {
                setContainsErrs(true);
                return;
              }
              // No errors:
              setCampaignThemeImages(themeImages);
              setCurrentStep(currentStep + 1);
            }}
          >
            Next Step
          </Button>
        </HStack>
      </Center>
    </Box>
  );
}

function Step6(props) {
  const {
    currentStep,
    setCurrentStep,
    campaignSocialImages,
    setCampaignSocialImages,
  } = props;

  const [socialImages, setSocialImages] = useState(campaignSocialImages || []);
  const [containsErrs, setContainsErrs] = useState(false);

  const addToSocialImage = (value) => {
    if (!value) return;
    setSocialImages([...socialImages, value]);
  };

  const removeSocialImage = (i) => {
    socialImages.splice(i, 1);
    setSocialImages([...socialImages]);
  };

  useEffect(() => {
    setCampaignSocialImages(campaignSocialImages);
  }, campaignSocialImages);

  return (
    <Box>
      <Center>
        <Heading fontSize="2xl">Culture</Heading>
      </Center>

      <Text my="2" fontSize="lg">
        Why does this story need to be told? What are some relevant cultural
        points?
      </Text>

      <Text my="2" fontSize="lg">
        Upload upto 5 culturally relevant images for audience feedback
      </Text>

      <SimpleGrid columns={5} spacing={2} my="3">
        {socialImages.map((socialImg) => {
          return (
            <Box>
              <Image
                borderWidth="2px"
                borderRadius="xl"
                boxSize="135"
                objectFit="cover"
                src={
                  socialImg
                    ? URL.createObjectURL(socialImg)
                    : "https://placehold.co/300x225"
                }
              />
            </Box>
          );
        })}
        {socialImages.length !== 5 && (
          <>
            <Input
              display="none"
              position="absolute"
              width="0px"
              name="cover-image-upload"
              id="cover-image-upload"
              accept="image/png, image/jpeg"
              type="file"
              onChange={(e) => {
                addToSocialImage(e.target.files[0]);
              }}
            ></Input>
            <FormLabel
              cursor="pointer"
              htmlFor="cover-image-upload"
              position="relative"
              fontSize="xl"
              width="133px"
              height="133px"
              background="blue.100"
              borderStyle="dashed"
              borderColor="blue.200"
              borderWidth="2px"
              borderRadius="xl"
              justifyContent="center"
            >
              <AbsoluteCenter>
                <Text
                  color="blue.300"
                  lineHeight="30px"
                  as="span"
                  fontSize="55px"
                >
                  +
                </Text>
              </AbsoluteCenter>
            </FormLabel>
          </>
        )}
      </SimpleGrid>
      {containsErrs && (
        <Text color="red.500">At least 2 images are required</Text>
      )}
      <Center>
        <HStack>
          <Button
            colorScheme="teal"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            Go Back
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              setContainsErrs(false);
              if (socialImages.length < 2) {
                setContainsErrs(true);
                return;
              }
              // No errors:
              setCampaignSocialImages(socialImages);
              setCurrentStep(currentStep + 1);
            }}
          >
            Next Step
          </Button>
        </HStack>
      </Center>
    </Box>
  );
}

function Step7(props) {
  const {
    currentStep,
    setCurrentStep,
    campaignInfluencerImages,
    setCampaignInfluencerImages,
  } = props;

  const [influencerImages, setInfluencerImages] = useState(
    campaignInfluencerImages || []
  );
  const [containsErrs, setContainsErrs] = useState(false);

  const addToInfluencerImage = (value) => {
    if (!value) return;
    setInfluencerImages([...influencerImages, value]);
  };

  const removeInfluencerImage = (i) => {
    influencerImages.splice(i, 1);
    setInfluencerImages([...influencerImages]);
  };

  useEffect(() => {
    setCampaignInfluencerImages(campaignInfluencerImages);
  }, campaignInfluencerImages);

  return (
    <Box>
      <Center>
        <Heading fontSize="2xl">Influencers</Heading>
      </Center>
      <Text my="2" fontSize="lg">
        Whether it’s coming of age, good versus evil or parenthood, your product
        has a theme! Tell us in pictures.
      </Text>

      <Text my="2" fontSize="lg">
        Upload upto 5 images of influencers, celebrities, spokespersons or
        friends
      </Text>

      <SimpleGrid columns={5} spacing={2} my="3">
        {influencerImages.map((influencerImg) => {
          return (
            <Box>
              <Image
                borderWidth="2px"
                borderRadius="xl"
                boxSize="135"
                objectFit="cover"
                src={
                  influencerImg
                    ? URL.createObjectURL(influencerImg)
                    : "https://placehold.co/300x225"
                }
              />
            </Box>
          );
        })}
        {influencerImages.length !== 5 && (
          <>
            <Input
              display="none"
              position="absolute"
              width="0px"
              name="cover-image-upload"
              id="cover-image-upload"
              accept="image/png, image/jpeg"
              type="file"
              onChange={(e) => {
                addToInfluencerImage(e.target.files[0]);
              }}
            ></Input>
            <FormLabel
              cursor="pointer"
              htmlFor="cover-image-upload"
              position="relative"
              fontSize="xl"
              width="133px"
              height="133px"
              background="blue.100"
              borderStyle="dashed"
              borderColor="blue.200"
              borderWidth="2px"
              borderRadius="xl"
              justifyContent="center"
            >
              <AbsoluteCenter>
                <Text
                  color="blue.300"
                  lineHeight="30px"
                  as="span"
                  fontSize="55px"
                >
                  +
                </Text>
              </AbsoluteCenter>
            </FormLabel>
          </>
        )}
      </SimpleGrid>
      {containsErrs && (
        <Text color="red.500">At least 2 images are required</Text>
      )}
      <Center>
        <HStack>
          <Button
            colorScheme="teal"
            onClick={() => setCurrentStep(currentStep - 1)}
          >
            Go Back
          </Button>
          <Button
            colorScheme="green"
            onClick={() => {
              setContainsErrs(false);
              if (influencerImages.length < 2) {
                setContainsErrs(true);
                return;
              }
              // No errors:
              setCampaignInfluencerImages(influencerImages);
              setCurrentStep(currentStep + 1);
            }}
          >
            Create Campaign
          </Button>
        </HStack>
      </Center>
    </Box>
  );
}

function Step8(props) {
  const {
    currentStep,
    setCurrentStep,
    submitNewCampaign,
    isSubmitting,
    setIsSubmitting,
  } = props;
  let navigate = useNavigate();

  if (!isSubmitting) {
    setIsSubmitting(true);
    submitNewCampaign().then((res) => {
      return navigate("/brandCampaigns");
    });
  }

  return (
    <Box>
      <Box>
        <Center>
          <Heading fontSize="2xl">Creating Campaign</Heading>
        </Center>
      </Box>
      <Box my="10">
        <Center>
          <Spinner color="blue.500" size="xl" />
        </Center>
      </Box>
    </Box>
  );
}

function CreateCampaign() {
  const [currentStep, setCurrentStep] = useState(0);

  const [campaignName, setCampaignName] = useState("");
  const [campaignCoverImage, setCampaignCoverImage] = useState("");
  const [campaignDescription, setCampaignDescription] = useState("");
  const [campaignMedium, setCampaignMedium] = useState("");
  const [campaignGenre, setCampaignGenre] = useState("");
  const [campaignHome, setCampaignHome] = useState("");
  const [campaignStage, setCampaignStage] = useState("");

  const [campaignTaglines, setCampaignTaglines] = useState([]);
  const [campaignConceptStorylines, setCampaignConceptStorylines] = useState(
    []
  );

  const [campaignCastImages, setCampaignCastImages] = useState([]);
  const [campaignThemeImages, setCampaignThemeImages] = useState([]);
  const [campaignSocialImages, setCampaignSocialImages] = useState([]);
  const [campaignInfluencerImages, setCampaignInfluencerImages] = useState([]);

  const [campaignInfluencers, setCampaignInfluencers] = useState([]);
  const [campaignSocial, setCampaignSocial] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitNewCampaign = async () => {
    if (isSubmitting) return;
    return new Promise(async (resolve, reject) => {
      setIsSubmitting(true);
      console.log("CREATING BRAND CAMPAIGN");
      await createBrandCampaign({
        name: campaignName,
        cover: campaignCoverImage,
        description: campaignDescription,
        medium: campaignMedium,
        genre: campaignGenre,
        //home: campaignHome,
        stage: campaignStage,

        messageTaglines: campaignTaglines,
        conceptStorylines: campaignConceptStorylines,
        castImages: campaignCastImages,
        themeImages: campaignThemeImages,
        socialImages: campaignSocialImages,
        influencerImages: campaignInfluencerImages,
      });
      resolve();
    });
  };

  const steps = [
    { title: "First" },
    { title: "Second" },
    { title: "Third" },
    { title: "Fourth" },
    { title: "Fifth" },
    { title: "Sixth" },
  ];

  const { activeStep } = useSteps({
    index: currentStep,
    count: steps.length,
  });

  const renderStep = (step) => {
    switch (currentStep) {
      case 0:
        return (
          <Step1
            campaignName={campaignName}
            campaignCoverImage={campaignCoverImage}
            campaignDescription={campaignDescription}
            campaignMedium={campaignMedium}
            campaignGenre={campaignGenre}
            campaignHome={campaignHome}
            campaignStage={campaignStage}
            setCampaignName={setCampaignName}
            setCampaignCoverImage={setCampaignCoverImage}
            setCampaignDescription={setCampaignDescription}
            setCampaignMedium={setCampaignMedium}
            setCampaignGenre={setCampaignGenre}
            setCampaignHome={setCampaignHome}
            setCampaignStage={setCampaignStage}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 1:
        return (
          <Step2
            campaignTaglines={campaignTaglines}
            setCampaignTaglines={setCampaignTaglines}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 2:
        return (
          <Step3
            campaignConceptStorylines={campaignConceptStorylines}
            setCampaignConceptStorylines={setCampaignConceptStorylines}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 3:
        return (
          <Step4
            campaignCastImages={campaignCastImages}
            setCampaignCastImages={setCampaignCastImages}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 4:
        return (
          <Step5
            campaignThemeImages={campaignThemeImages}
            setCampaignThemeImages={setCampaignThemeImages}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 5:
        return (
          <Step6
            campaignSocialImages={campaignSocialImages}
            setCampaignSocialImages={setCampaignSocialImages}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 6:
        return (
          <Step7
            campaignInfluencerImages={campaignInfluencerImages}
            setCampaignInfluencerImages={setCampaignInfluencerImages}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
      case 7:
        return (
          <Step8
            isSubmitting={isSubmitting}
            setIsSubmitting={setIsSubmitting}
            submitNewCampaign={submitNewCampaign}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
    }
  };

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      h="200px"
      color="blackAlpha.700"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        <VStack>
          <Box mt="8">
            <Heading
              color={useColorModeValue("gray.1000", "gray.100")}
              fontSize="2xl"
            >
              Create a Campaign
            </Heading>
          </Box>
          <Box mt="30px" minW="2xl">
            <Stepper
              color={useColorModeValue("gray.1000", "gray.100")}
              index={currentStep}
            >
              {steps.map((step, index) => (
                <Step key={index}>
                  <StepIndicator>
                    <StepStatus
                      complete={<StepIcon />}
                      incomplete={<StepNumber />}
                      active={<StepNumber />}
                    />
                  </StepIndicator>

                  <StepSeparator />
                </Step>
              ))}
            </Stepper>
          </Box>

          <Card
            mx="5"
            my="5"
            p="3"
            minW="2xl"
            bg={useColorModeValue("gray.100", "gray.900")}
          >
            {renderStep(currentStep)}
          </Card>
        </VStack>
      </GridItem>

      {/*
      <GridItem area={'footer'}>
        <Box
          p="30px"
          width="100%"
          bg={useColorModeValue('gray.600', 'gray.600')}
          color={useColorModeValue('gray.100', 'gray.100')}
        >
          <Center>
            <Text>Copyright © {new Date().getFullYear()} Hubit</Text>
          </Center>
        </Box>
      </GridItem>
      */}
    </Grid>
  );
}

export default CreateCampaign;
